const isInternetExplorer = () => {
  return "ActiveXObject" in window;
};
export default isInternetExplorer;
